import gsap from 'gsap'

function init() {
  var templatesContainer = document.querySelectorAll(
    '.com-sec-templates-promo__templates:not(.is-initialized)',
  )
  var breakpoint = 480

  ;[].forEach.call(templatesContainer, function (templateContainer) {
    var initialTemplates = templateContainer.querySelectorAll('.com-sec-templates-promo__template')
    var duration = {
      desktop: initialTemplates.length * 10,
      mobile: initialTemplates.length * 14,
    }
    var viewportWidth = window.innerWidth

    for (var i = 0; i < initialTemplates.length; i++) {
      var templatesCopied = initialTemplates[i].cloneNode(true)

      templateContainer.appendChild(templatesCopied)
    }

    var templates = templateContainer.querySelectorAll('.com-sec-templates-promo__template')

    templateContainer.classList.add(
      'com-sec-templates-promo__templates--offset',
      'com-sec-templates-promo__templates--overflow-hidden',
    )

    templateContainer.querySelectorAll('.com-sec-templates-promo__template').forEach(function (n) {
      n.classList.add(
        'com-sec-templates-promo__template--absolute',
        'com-sec-templates-promo__template--offset',
      )
    })

    gsap.set(templates, {
      y: function (index, element) {
        return initYPos(index, element)
      },
      x: function (index, element) {
        return initXPos(index, element)
      },
    })
    ;[].forEach.call(templates, function (t) {
      var link = t.querySelector('a')

      if (link) {
        link.setAttribute('tabindex', '-1')
      }
    })

    var animateTemplates = gsap.to(templates, {
      duration: window.innerWidth > breakpoint ? duration.desktop : duration.mobile,
      ease: 'none',
      y: function (i, e, arr) {
        return window.innerWidth > breakpoint
          ? '-=' + (e.getBoundingClientRect().height * arr.length) / 2
          : 0
      },
      x: function (i, e, arr) {
        return window.innerWidth < breakpoint
          ? '-=' + e.getBoundingClientRect().width * arr.length
          : 0
      },
      modifiers: {
        y: gsap.utils.unitize(function (y) {
          var templateCardHeight = animateTemplates._targets[0].getBoundingClientRect().height
          var height = (templateCardHeight * animateTemplates._targets.length) / 2

          return window.innerWidth > breakpoint ? wrap(y, 0, height) : 0
        }),
        x: gsap.utils.unitize(function (x) {
          var templateCardWidth = animateTemplates._targets[0].getBoundingClientRect().width
          var width = templateCardWidth * animateTemplates._targets.length

          return window.innerWidth < breakpoint ? wrap(x, 0, width) : 0
        }),
      },
      repeat: -1,
    })

    function wrap(value, min, max) {
      var v = value - min
      var r = max - min
      return ((r + (v % r)) % r) + min
    }

    function initYPos(index, element) {
      return window.innerWidth > breakpoint
        ? (index * element.getBoundingClientRect().height) / 2
        : 0
    }

    function initXPos(index, element) {
      return window.innerWidth < breakpoint ? index * element.getBoundingClientRect().width : 0
    }

    function initEvents() {
      templateContainer.addEventListener('mouseenter', function () {
        if (window.innerWidth > breakpoint) {
          animateTemplates.pause()
        }
      })

      templateContainer.addEventListener('mouseleave', function () {
        if (window.innerWidth > breakpoint) {
          animateTemplates.play()
        }
      })
    }

    initEvents()

    window.addEventListener('resize', function () {
      if (viewportWidth === window.innerWidth) {
        return
      }

      viewportWidth = window.innerWidth
      animateTemplates.invalidate()

      gsap
        .set(templates, {
          y: function (index, element) {
            return initYPos(index, element)
          },
          x: function (index, element) {
            return initXPos(index, element)
          },
        })
        .then(function () {
          if (window.innerWidth > breakpoint) {
            animateTemplates.duration(duration.desktop).restart()
          } else {
            animateTemplates.duration(duration.mobile).restart()
          }
        })
    })

    templateContainer.classList.add('is-initialized')
  })

  function initComponentCard() {
    var cards = document.querySelectorAll('.js-component-card')

    ;[].forEach.call(cards, function (card) {
      var link = card.querySelector('.js__event-link')

      card.addEventListener('click', function (e) {
        var selection = document.getSelection()

        if (selection && selection.toString()) {
          return
        }

        if (!link.contains(e.target)) {
          link.click()
        }
      })

      card.addEventListener('focusin', function (e) {
        if (link === e.target) {
          card.classList.add('is-focused')
        }
      })

      card.addEventListener('focusout', function () {
        card.classList.remove('is-focused')
      })
    })
  }

  initComponentCard()
}

export default {init}
